<template>
  <AsyncImage :src="`/assets/nami/reactions/${reaction}.png`" />
</template>

<script setup lang="ts">
defineProps<{
  reaction: "funny" | "like" | "love" | "sad" | "support" | "wow";
}>();
</script>
